export default [
    {
        path: '/agent',
        props: true,
        component: () => import('@/views/Agent'),
    },
    {
        path: '/agent/:id',
        props: true,
        component: () => import('@/views/Agent/View'),
    },
];
